import { type FC, useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useSwipeable } from 'react-swipeable'
import styled from 'styled-components'

import { AllIcons } from 'helpers/allIcons'
import { useGlobalStore } from 'store/global'

import './_verifyNav.scss'

interface Props {
    isDesktop?: boolean
}

const VerifyNav: FC<Props> = ({ isDesktop = false }) => {
    const { t } = useTranslation()
    const { accountSetupPopup, setAccountSetupPopup } = useGlobalStore()
    const [visible, setVisible] = useState(true)

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false)
        }, 10000)

        return () => clearTimeout(timer)
    }, [])

    const handlers = useSwipeable({
        onSwipedDown: () => setVisible(false),
        trackMouse: true
    })

    if (!visible) {
        return null
    }

    return (
        <VerifyNavContainer
            $isDesktop={isDesktop}
            className={`verify ${accountSetupPopup.visible ? 'active' : ''}`}
            {...handlers}
        >
            <div className='verify__wrapper'>
                <div className='left__side--wrapper'>
                    <img src={AllIcons.shield} alt='guard_logo' />
                    <div className='verify__text'>
                        <span className='verify__text__link'>
                            {t('completeAccountSetup')}
                        </span>

                        <p>{t('verifyYourAccountToGetPosting')}</p>
                    </div>
                </div>
                <Link
                    to='/settings/general/payout-settings/payment-method'
                    className='arrows__wrapper'
                    onClick={() =>
                        setAccountSetupPopup({
                            visible: false
                        })
                    }
                >
                    <img
                        className='arrow__flashing first'
                        src={AllIcons.chevron_right}
                        alt='arrows'
                    />
                    <img
                        className='arrow__flashing second'
                        src={AllIcons.chevron_right}
                        alt='arrows'
                    />
                    <img
                        className='arrow__flashing third'
                        src={AllIcons.chevron_right}
                        alt='arrows'
                    />
                </Link>
            </div>
        </VerifyNavContainer>
    )
}

export default VerifyNav

interface VerifyNavContainerProps {
    $isDesktop: boolean
}

const VerifyNavContainer = styled.div<VerifyNavContainerProps>`
    ${props =>
        props.$isDesktop &&
        `
        position: fixed;
        right: 2rem;
        bottom: 4rem;
        left: unset;
        width: 41rem;
        display: flex;
        align-content: center;
        justify-content: center;
        height: 11.4rem !important;
        padding: 2rem 4rem !important;

        .verify__wrapper {
            flex: 1;
        }
        .arrows__wrapper {
        cursor: pointer;

        }
    `}
`
